var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('div',{staticClass:"schedules-new-form"},[_c(_setup.schedulesForm,{attrs:{"method":'edit',"title":_setup.formTitle,"id":_setup.props.parentData.row.id},on:{"close-form":_setup.closeForm}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }